export default {
  green: { color: '#1FAE96', backgroundColor: '#E9F7F4', accessibleColor: '#167B6A' },
  amber: { color: '#F5AF22', backgroundColor: '#FFF8EB', accessibleColor: '#996806' },
  red: { color: '#E14E38', backgroundColor: '#FCEDEB', accessibleColor: '#B43E2C' },
  gray: { color: '#617080', backgroundColor: '#F7F9FA', accessibleColor: '#617080' },
};
